import { render } from "./AddNewStockAdjustment.vue?vue&type=template&id=310855a3"
import script from "./AddNewStockAdjustment.vue?vue&type=script&lang=js"
export * from "./AddNewStockAdjustment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__